import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle, XCircle, LockSimple, Trophy } from "@phosphor-icons/react";

export const VideoQuiz = ({ video, onPassed }) => {
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setAnswers([]); setResult(null); }, [video.id]);

  if (!video.watched_at) {
    return (
      <div className="p-5 text-sm text-muted-foreground flex items-center gap-2" data-testid="video-quiz-locked">
        <LockSimple size={16} /> El cuestionario se habilita cuando termines de ver el video.
      </div>
    );
  }

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/training/videos/${video.id}/quiz`, { answers });
      setResult(data);
      if (data.passed) { toast.success("¡Aprobado! 3 de 3"); onPassed(); }
      else toast.error(`${data.score} de 3. Revisa las respuestas e inténtalo otra vez.`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo enviar");
    } finally { setBusy(false); }
  };

  const retry = () => { setAnswers([]); setResult(null); };

  return (
    <div className="p-5 space-y-4" data-testid="video-quiz">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-sm">Cuestionario · debes acertar las 3</div>
        {(video.passed || result?.passed) && (
          <span className="text-xs text-emerald-600 flex items-center gap-1" data-testid="video-quiz-passed"><Trophy size={14} weight="fill" /> Aprobado</span>
        )}
      </div>
      {video.quiz.map((q, qi) => {
        const r = result?.results?.[qi];
        return (
          <div key={qi} className="space-y-1.5" data-testid={`video-quiz-q${qi}`}>
            <div className="text-sm font-medium">{qi + 1}. {q.question}</div>
            {q.options.map((op, oi) => {
              const picked = answers[qi] === oi;
              const tone = r ? (oi === r.correct_index ? "border-emerald-500 bg-emerald-500/10" : picked ? "border-red-500 bg-red-500/10" : "border-border")
                : picked ? "border-primary bg-primary/10" : "border-border hover:bg-muted/40";
              return (
                <button key={oi} disabled={!!result} onClick={() => setAnswers((a) => { const n = [...a]; n[qi] = oi; return n; })}
                  className={`w-full text-left text-sm rounded-md border px-3 py-2 transition-colors ${tone}`} data-testid={`video-quiz-q${qi}-o${oi}`}>
                  {op}
                </button>
              );
            })}
            {r && (
              <div className={`text-xs flex items-start gap-1 ${r.correct ? "text-emerald-600" : "text-red-600"}`}>
                {r.correct ? <CheckCircle size={13} weight="fill" /> : <XCircle size={13} weight="fill" />} {r.explanation}
              </div>
            )}
          </div>
        );
      })}
      {result && !result.passed ? (
        <Button size="sm" variant="outline" onClick={retry} data-testid="video-quiz-retry">Intentar de nuevo</Button>
      ) : !result && (
        <Button size="sm" disabled={busy || answers.filter((a) => a !== undefined).length < video.quiz.length} onClick={submit} data-testid="video-quiz-submit">
          Enviar respuestas
        </Button>
      )}
    </div>
  );
};
